export default __webpack_public_path__ + "static/graphic-process-5337003a760a4096ad68415b489d0bab.svg";